import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CurrentUser } from "./types";
import { eventsApi } from "../events/api";

export interface User {
  userInfo: CurrentUser | null;
}

const initialState: User = {
  userInfo: null,
};

const currentUser = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserInfo(state, action: PayloadAction<CurrentUser | null>) {
      state.userInfo = action.payload;
    },
    logout(state) {
      localStorage.removeItem("access-token");
      localStorage.removeItem("refresh-token");
      localStorage.removeItem("chat-token");
      state.userInfo = null;
      eventsApi.util.invalidateTags([{ type: "UserEvents", id: "LIST" }]);
    },
    incrementFollowingCount(state) {
      if (typeof state.userInfo?.following_count === "number")
        state.userInfo.following_count = state.userInfo.following_count + 1;
    },
    decrementFollowingCount(state) {
      if (typeof state.userInfo?.following_count === "number")
        state.userInfo.following_count = state.userInfo.following_count - 1;
    },
  }
});
export const { setUserInfo, logout, incrementFollowingCount, decrementFollowingCount } = currentUser.actions;


export default currentUser.reducer;
